import Quill from 'quill';
import Pickr from '@simonwep/pickr';
/* Creates a hidden color input element  */
function initializeColorPicker() {
    // This btn element is the custom color picker button in the Quill toolbar
    const btn = document.querySelector('.ql-customColorPicker');
    // Next to it, we'll create a hidden container for our own color picker
    const pickrContainerWrapper = document.createElement('button');
    const pickrContainer = document.createElement('div');
    pickrContainer.id = 'customColorPicker';
    pickrContainerWrapper.classList.add('ql-hidden‐color‐picker');
    if (btn) {
        // Adds the Quill's color icon to the button
        // @ts-ignore
        btn.innerHTML = Quill.import('ui/icons').color;
        btn.insertAdjacentElement('beforebegin', pickrContainerWrapper);
        pickrContainerWrapper.appendChild(pickrContainer);
    }
    const pickr = Pickr.create({
        el: '#customColorPicker',
        theme: 'monolith',
        position: 'bottom-end',
        components: {
            hue: true,
            interaction: {
                input: true,
                hex: true,
                rgba: true,
            },
        },
    });
    return pickr;
}
export default {
    initializeColorPicker,
};
//# sourceMappingURL=util.js.map